export default __webpack_public_path__ + "static/media/gate.935f504d.svg";